import { Component, input, InputSignal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  imports: [TranslatePipe, NzBreadCrumbModule, RouterModule],
})
export class PageTitleComponent {
  public pageTitle: InputSignal<string> = input.required<string>();
  public breadcrumbs: InputSignal<{label: string, path: string | null}[]> = input<{label: string, path: string | null}[]>([]);
  public documentId: InputSignal<string | null> = input<string | null>(null);

}
